module.exports = __webpack_public_path__ + "img/BC-alt.b4ce4457.svg";